import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { logout } from "../../api/apiUser";

const AUTO_LOGOUT_TIME = 30 * 60 * 1000; // 15 * 1000;

const InactivityTimeout = ({ children }) => {
  const history = useHistory();
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    const resetTimer = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const id = setTimeout(() => {
        handleLogout();
      }, AUTO_LOGOUT_TIME);
      setTimeoutId(id);
    };

    const handleLogout = async () => {
      try {
        await logout();
        history.push("/admin/dashboard");
      } catch (error) {
        console.error("Logout failed", error);
      }
    };

    // Set up event listeners for user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId, history]);

  return <>{children}</>;
};

export default InactivityTimeout;

